import axios from "axios";
import { parsePositiveId } from "./onboardingTemplateFormShared.mjs";

const ownerLabelFromRecord = (item = {}) => {
  const label = String(
    item.default_owner_name
    || item.owner_name
    || item.display_name
    || item.name
    || item.email
    || ""
  ).trim();
  if (label) return label;
  const ownerId = parsePositiveId(item.default_owner_user_id ?? item.owner_user_id ?? item.user_id);
  return ownerId ? `#${ownerId}` : "-";
};

const normalizeOwnerOption = (item = {}) => {
  const value = parsePositiveId(
    item.value
    ?? item.id
    ?? item.user_id
    ?? item.default_owner_user_id
    ?? item.owner_user_id
  );
  if (!value) return null;
  const label = ownerLabelFromRecord(item);
  return { value, label: label === "-" ? `#${value}` : label };
};

const ownerSeedsFromTemplatePayload = (payload = {}) => {
  const template = payload.template || payload || {};
  const stageOwners = (Array.isArray(payload.stages) ? payload.stages : []).map((stage) => ({
    owner_user_id: stage?.owner_user_id,
    owner_name: stage?.owner_name,
  }));
  return [{ default_owner_user_id: template.default_owner_user_id, default_owner_name: template.default_owner_name }, ...stageOwners];
};

export default {
  data() {
    return {
      ownerLoading: false,
      ownerOptions: [],
      ownerRequestSeq: 0,
      ownerSearchTimer: null,
      lastDefaultOwnerUserId: null,
    };
  },
  computed: {
    ownerItems() {
      return this.ownerOptions;
    },
  },
  beforeUnmount() {
    if (this.ownerSearchTimer) clearTimeout(this.ownerSearchTimer);
  },
  methods: {
    ownerLabel(item) {
      return ownerLabelFromRecord(item);
    },
    mergeOwnerOptions(items = []) {
      const optionsById = new Map(this.ownerOptions.map((item) => [item.value, item]));
      for (const item of Array.isArray(items) ? items : []) {
        const option = normalizeOwnerOption(item);
        if (option) optionsById.set(option.value, option);
      }
      this.ownerOptions = Array.from(optionsById.values()).sort((left, right) =>
        String(left.label || "").localeCompare(String(right.label || ""), this.$i18n?.locale || undefined)
      );
    },
    mergeTemplateOwnerOptions(payload) {
      this.mergeOwnerOptions(ownerSeedsFromTemplatePayload(payload));
    },
    scheduleOwnerSearch(search) {
      if (this.ownerSearchTimer) clearTimeout(this.ownerSearchTimer);
      this.ownerSearchTimer = setTimeout(() => this.loadOwners(search), 220);
    },
    syncStageOwnersFromDefaultOwner(value) {
      const previousOwnerId = parsePositiveId(this.lastDefaultOwnerUserId);
      const nextOwnerId = parsePositiveId(value);
      this.createForm.stages = (this.createForm.stages || []).map((stage) => {
        const currentOwnerId = parsePositiveId(stage?.owner_user_id);
        if (!currentOwnerId || (previousOwnerId && currentOwnerId === previousOwnerId)) {
          return { ...stage, owner_user_id: nextOwnerId };
        }
        return stage;
      });
      this.lastDefaultOwnerUserId = nextOwnerId;
    },
    async loadOwners(search = "") {
      const requestSeq = this.ownerRequestSeq + 1;
      this.ownerRequestSeq = requestSeq;
      this.ownerLoading = true;
      try {
        const { data } = await axios.get("/ncrm/onboarding/owners", {
          params: { search: String(search || "").trim() || undefined, limit: 100 },
        });
        if (requestSeq === this.ownerRequestSeq) {
          this.mergeOwnerOptions(Array.isArray(data?.items) ? data.items : []);
        }
      } catch (error) {
        console.error("[ncrm-onboarding-templates] load owners failed", error);
        this.showSnackbar(error?.response?.data?.error || this.$t("ncrm.onboarding.templates.messages.ownerLoadError"), "error");
      } finally {
        if (requestSeq === this.ownerRequestSeq) this.ownerLoading = false;
      }
    },
  },
};
